import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforschooltripsinpune() {



  const cardData = {
"keyword": "Bus Hire for School Trips in Pune",

"headingDescription":
  "Aaradhya Travels offers safe and reliable Bus Hire for School Trips in Pune for educational tours, school picnics, college excursions, sports events, and study visits. We provide well-maintained AC and Non-AC buses with experienced drivers trained for student transportation. Our priority is child safety, punctual service, and comfortable group travel across Pune and nearby destinations with proper seating capacity, GPS-enabled vehicles, and flexible booking options for schools and institutions.",

"topPlaces": [

{
"title": "Bhimashankar",
"description":
"Bhimashankar is a famous Jyotirlinga temple surrounded by dense forests and wildlife sanctuary. It is a top spiritual and nature trekking destination for group trips from Pune."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination known for clean beaches, sea forts, and peaceful surroundings. It is ideal for weekend group tours and beach outings from Pune using buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its historic sea fort located on an island. It is a popular coastal heritage sightseeing destination for group travelers from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Kolad",
"description":
"Kolad is an adventure destination famous for river rafting on the Kundalika River, camping, and outdoor activities. It is widely chosen for group adventure trips from Pune."
},
{
"title": "Shirdi",
"description":
"Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. It attracts devotees from across the country and is a highly preferred group travel destination from Pune using 32 seater buses for comfortable spiritual tours."
},
{
"title": "Nashik",
"description":
"Nashik is a major pilgrimage and wine tourism destination known for Trimbakeshwar Temple, river ghats, and vineyards. It is a popular group travel route from Pune for both religious and leisure tours."
},
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using buses."
},
{
"title": "Ratnagiri",
"description":
"Ratnagiri is a beautiful Konkan coastal destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is popular for long-distance group travel from Pune."
}
],



services: [
  {
    name: "Bus Hire for School Trips in Hadapsar Pune",
    description: "Bus hire for school trips in Hadapsar Pune service provides safe and reliable transportation for educational tours, student outings, annual functions, and one-day picnic trips. Spacious buses with comfortable seating ensure pleasant travel experiences suitable for students and teachers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from schools, colleges, coaching institutes, and educational campuses across Hadapsar Pune. Flexible booking options allow convenient school trip bus reservations."
  },
  {
    name: "Bus Hire for School Trips in Pimpri Chinchwad",
    description: "Bus hire for school trips in Pimpri Chinchwad service offers dependable transportation for educational tours, picnic outings, sports events, and student travel requirements. Spacious buses ensure comfortable seating and smooth journeys suitable for school groups and faculty members. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pimpri Chinchwad Pune. Flexible booking options allow convenient school trip bus reservations."
  },
  {
    name: "Bus Hire for School Picnic Morachi Chincholi",
    description: "Bus hire for school picnic Morachi Chincholi service provides comfortable transportation for educational outings, nature tours, student travel, and school picnic trips. Spacious seating and smooth highway travel ensure pleasant journeys suitable for students, teachers, and school groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, homes, and educational campuses across Pune. Flexible booking options allow convenient Morachi Chincholi picnic bus reservations."
  },
  {
    name: "Bus Hire for School Picnic Pune to Mahabaleshwar",
    description: "Bus hire for school picnic Pune to Mahabaleshwar service offers safe transportation for educational tours, sightseeing journeys, school outings, and student picnic trips. Spacious buses and smooth ghat road travel ensure comfortable journeys suitable for students and faculty groups. Professional drivers ensure safe transportation and punctual pickup services throughout the Mahabaleshwar route. Pickup services are available from schools, colleges, coaching institutes, and educational campuses across Pune. Flexible booking options allow convenient Mahabaleshwar picnic bus reservations."
  },
  {
    name: "Bus Hire for School Picnic Pune to Alibaug",
    description: "Bus hire for school picnic Pune to Alibaug service provides dependable transportation for beach outings, educational tours, sightseeing journeys, and student group travel. Spacious buses ensure smooth highway journeys suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Alibaug route. Pickup services are available from schools, colleges, homes, and educational campuses across Pune. Flexible booking options allow convenient Alibaug picnic bus reservations."
  },
  {
    name: "Pune to Mumbai School Picnic Bus Hire",
    description: "Pune to Mumbai school picnic bus hire service offers comfortable transportation for educational tours, museum visits, sightseeing trips, and student travel from Pune. Spacious seating and smooth expressway travel ensure pleasant journeys suitable for school groups and faculty members. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient Mumbai school trip bus reservations."
  },
  {
    name: "Pune to Water Park School Trip Bus Hire",
    description: "Pune to water park school trip bus hire service provides safe and spacious transportation for recreational outings, student picnic trips, and educational travel. Comfortable seating and smooth highway journeys ensure enjoyable travel experiences suitable for students and teachers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient water park school trip bus reservations."
  },
  {
    name: "Pune to Imagica School Trip Bus Hire",
    description: "Pune to Imagica school trip bus hire service offers dependable transportation for amusement park outings, educational tours, and student group travel from Pune. Spacious buses and comfortable seating ensure smooth expressway journeys suitable for students and faculty members. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient Imagica school trip bus reservations."
  },
  {
    name: "Pune to Lonavala School Picnic Bus Hire",
    description: "Pune to Lonavala school picnic bus hire service provides comfortable transportation for hill station outings, sightseeing tours, educational travel, and student picnic trips from Pune. Spacious buses and smooth expressway travel ensure pleasant journeys suitable for school groups and teachers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, homes, and educational campuses across Pune. Flexible booking options allow convenient Lonavala picnic bus reservations."
  },
  {
    name: "Pune to Sinhagad Fort School Trip Bus Hire",
    description: "Pune to Sinhagad Fort school trip bus hire service offers reliable transportation for historical tours, educational outings, sightseeing journeys, and student group travel from Pune. Comfortable seating and smooth travel ensure pleasant journeys suitable for students, teachers, and school groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient Sinhagad school trip bus reservations."
  },
  {
    name: "School Bus Rental Pune for One Day",
    description: "School bus rental Pune for one day service provides safe and affordable transportation for educational tours, annual events, picnic outings, sports activities, and local student travel. Spacious buses ensure comfortable seating suitable for students and faculty groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, homes, and educational campuses across Pune. Flexible booking options allow convenient one-day school bus reservations."
  },
  {
    name: "School Bus Hire for Outstation Pune",
    description: "School bus hire for outstation Pune service offers dependable long-distance transportation for educational tours, sightseeing journeys, annual trips, and student travel requirements. Spacious seating and luggage capacity ensure smooth highway journeys suitable for school groups and faculty members. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient outstation school bus reservations."
  },
  {
    name: "School Bus Hire for Annual Trip Pune",
    description: "School bus hire for annual trip Pune service provides comfortable transportation for yearly educational tours, sightseeing journeys, student outings, and school travel requirements. Spacious buses and smooth travel performance ensure pleasant journeys suitable for students and teaching staff. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient annual trip bus reservations."
  },
  {
    name: "School Bus Hire with Driver Pune",
    description: "School bus hire with driver Pune service offers safe and professional transportation for educational tours, picnic outings, sports travel, and school functions. Spacious buses and experienced chauffeurs ensure comfortable travel experiences suitable for students and faculty groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from schools, colleges, coaching institutes, and educational campuses across Pune. Flexible booking options allow convenient school bus reservations."
  },
  {
    name: "AC School Bus Hire Pune",
    description: "AC school bus hire Pune service provides premium air-conditioned transportation for educational tours, school outings, annual functions, and long-distance student travel. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient AC school bus reservations."
  },
  {
    name: "Non AC School Bus Hire Pune",
    description: "Non AC school bus hire Pune service offers affordable transportation for educational tours, local sightseeing, school outings, and student group travel requirements. Spacious seating and smooth travel ensure comfortable journeys suitable for students and teachers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from schools, colleges, homes, and educational campuses across Pune. Flexible booking options allow convenient non AC school bus reservations."
  },
  {
    name: "Safe School Transport Pune",
    description: "Safe school transport Pune service provides reliable and secure transportation for educational tours, school travel, student outings, and picnic journeys. Spacious buses with professional chauffeurs ensure comfortable travel experiences suitable for students and faculty members. Drivers follow safe driving practices and ensure dependable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, and educational campuses across Pune. Flexible booking options allow convenient safe school transport reservations."
  },
  {
    name: "Affordable School Bus Hire Pune",
    description: "Affordable school bus hire Pune service offers economical transportation for educational tours, annual functions, student outings, sports events, and local or outstation school travel. Spacious buses ensure comfortable seating suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, and educational campuses across Pune. Flexible booking options allow convenient affordable school bus reservations."
  }
],

tableData: [
  ["Bus Hire for School Trips in Hadapsar Pune", "Bus Hire for School Trips in Pimpri Chinchwad"],
  ["Bus Hire for School Picnic Morachi Chincholi", "Bus Hire for School Picnic Pune to Mahabaleshwar"],
  ["Bus Hire for School Picnic Pune to Alibaug", "Pune to Mumbai School Picnic Bus Hire"],
  ["Pune to Water Park School Trip Bus Hire", "Pune to Imagica School Trip Bus Hire"],
  ["Pune to Lonavala School Picnic Bus Hire", "Pune to Sinhagad Fort School Trip Bus Hire"],
  ["School Bus Rental Pune for One Day", "School Bus Hire for Outstation Pune"],
  ["School Bus Hire for Annual Trip Pune", "School Bus Hire with Driver Pune"],
  ["AC School Bus Hire Pune", "Non AC School Bus Hire Pune"],
  ["Safe School Transport Pune", "Affordable School Bus Hire Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Bus Hire for School Trips in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable bus hire service for school trips in Pune with comfortable vehicles, professional drivers, and safe travel arrangements for educational tours and student outings."
      },
      {
        WhyChooseheading: "Affordable School Trip Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable bus hire packages for school trips in Pune with transparent pricing, flexible booking plans, and complete transportation support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 School Bus Booking Service",
        WhyChoosedescription: "Our school trip bus rental service in Pune operates 24 hours for educational tours, picnic outings, industrial visits, sports events, and student group travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Well-Maintained School Trip Buses",
        WhyChoosedescription: "All buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable student travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Educational Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day school trips, weekend educational tours, industrial visits, and multi-day student travel packages according to school requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses suitable for school groups and educational institutions."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Schools",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup and drop services from schools, colleges, coaching institutes, and major Pune locations including Baner, Wakad, Pimpri, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Student Safety",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and disciplined transportation for school students, teachers, and educational staff."
      }
    ]
  };

  const faqData = [
    { question: "What is bus hire for school trips in Pune?", answer: "Bus hire for school trips in Pune provides safe and comfortable transportation for educational tours, picnics, industrial visits, sports events, and student outings." },
    { question: "Is school trip bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 bus hire service for school trips in Pune." },
    { question: "Which seating capacity buses are available for school trips?", answer: "Aaradhya Travels offers 20 seater, 25 seater, 32 seater, 35 seater, 45 seater, and 50 seater buses for school and college travel." },
    { question: "Can I book buses for outstation school tours?", answer: "Yes, customers can book buses for outstation educational tours, industrial visits, and student holiday trips." },
    { question: "Do you provide AC and Non-AC buses for school trips?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC buses for comfortable and budget-friendly student travel." },
    { question: "Are the buses maintained properly for student travel?", answer: "Yes, all buses are regularly cleaned and maintained for safe and comfortable school transportation." },
    { question: "Can schools book buses online in Pune?", answer: "Yes, schools and institutions can easily book bus hire service online or through phone booking." },
    { question: "Do you provide buses for sports events and educational tours?", answer: "Yes, Aaradhya Travels provides buses for sports competitions, educational tours, industrial visits, and school outings." },
    { question: "Are school trip bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for school trip bus hire?", answer: "Yes, advance booking is available and recommended during school picnic seasons, holidays, and annual educational tour periods." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Avinash Kulkarni",
    feedback:
      "We arranged bus hire for school trips in Pune for our students’ educational tour, and everything was managed very smoothly. The bus was clean, safe, and comfortable for the children throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Reema Joshi",
    feedback:
      "Bus hire for school trips in Pune worked perfectly for our school excursion. The service was punctual, the vehicle was well-maintained, and the overall travel experience was safe and organized.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for School Trips in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/bus-hire-for-school-trips-pune.jpg",
  "description": "Book Bus Hire for School Trips in Pune with Aaradhya Travels for safe and comfortable student travel. Affordable AC and Non-AC buses available for school picnics, educational tours, water parks, and outstation trips like Mahabaleshwar, Alibaug, Mumbai, and Morachi Chincholi.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3184"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/bus-hire-for-school-trips-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Bus Hire for School Trips in Pune | Safe School Picnic Bus | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Bus for School Trips in Pune with Aaradhya Travels. Safe and reliable AC and Non-AC buses available for school picnics, educational tours, water parks, and outstation trips to Mahabaleshwar, Alibaug, Mumbai, Morachi Chincholi, and more."
  />

  <meta
    name="keywords"
    content="Bus hire for school trips in Hadapsar Pune, Bus hire for school trips in Pimpri Chinchwad, Bus hire for school picnic Morachi Chincholi, Bus hire for school picnic Pune to Mahabaleshwar, Bus hire for school picnic Pune to Alibaug, Pune to Mumbai school picnic bus hire, Pune to water park school trip bus hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforschooltripsinpune;